import React, { useRef, useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faCheckCircle, faTimesCircle, faCheck} from "@fortawesome/free-solid-svg-icons";
import { RestAPI } from "@aws-amplify/api-rest";
import PriceListServices from "./PriceListServices";
import PriceListDiscounts from "./PriceListDiscounts";
import SelfHelp from "../Utils/SelfHelp";
import withName from "../../hoc/withName";
import LoadingDialog from "../Utils/LoadingDialog";
import { toast } from "react-toastify";
import { CONTRATO_ANUAL, CONTRATO_MENSUAL, CONTRATO_SEMESTRAL, CONTRATO_TRIMESTAL, SERVICE_DROPCONTROL_API, SERVICE_DROPCONTROL_DROPCONTROL, SERVICE_DROPCONTROL_LITE, SERVICE_DROPCONTROL_PREMIUM } from "../../utils/BillingUtils";
import { SERVICE_ADDITIONAL_API, SERVICE_ADDITIONAL_USER, SERVICE_DATAPLAN, SERVICE_DROPCONTROL, SERVICE_EXT_DATASOURCE, SERVICE_IMAGES, SERVICE_SMS_CALLS } from "../../utils/BillingUtils";

import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";
import { MultiSelect } from "primereact/multiselect";import { InputSwitch } from "primereact/inputswitch";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import ButtonPrime from "../PrimeComponents/ButtonPrime";

const PriceList = () => {

    const { t, i18n } = useTranslation();
    const [data, setData] = useState(null);
    const [countries, setCountries] = useState(null);
    const [onSendForm, setOnSendForm] = useState(false);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const gridRef = useRef(null);
    const names = useMemo(() => [
        t("billing.priceListPage.table.name"),
        t("billing.priceListPage.table.countryType"),
        t("billing.priceListPage.table.default_list"),
    ], [t]);
    const [onCreate, setOnCreate] = useState(false);
    useEffect(() => {
        if(countries){
            countries.forEach(c => {
                c.nombre = t(`countries.${c.tipo_pais_id}`);
            });
        }
    },[countries,t]);
    const defaultPriceList ={
        "nombre": "",
        "config_descuentos": [
            {
                "rangeMin": 0,
                "rangeMax": null,
                "discount": null,
                "includedUser": null,
                "includedAPI": null,
                "SMS": null,
                "calls": null
            }
        ],
        "precios": [
            {
                "servicio_id": 1,
                "config": {
                    [SERVICE_DROPCONTROL_API]: {
                        "API-X1": null,
                        "API-M1": null,
                        "API-C1": null,
                        "API-V1": null,
                    },
                    [SERVICE_DROPCONTROL_LITE]: {
                        "LITE-X1": null,
                        "LITE-M1": null,
                        "LITE-C1": null,
                        "LITE-V1": null,
                    },
                    [SERVICE_DROPCONTROL_DROPCONTROL]: {
                        "EXP-X1": null,
                        "EXP-M1": null,
                        "EXP-C1": null,
                        "EXP-V1": null,
                    },
                    [SERVICE_DROPCONTROL_PREMIUM]: {
                        "PREM-X1": null,
                        "PREM-M1": null,
                        "PREM-C1": null,
                        "PREM-V1": null,
                    },
                    "FREE": {
                        "valor": "0"
                    }
                },
                "valor": null
            },
            {
                "servicio_id": 2,
                "config": null,
                "valor": null
            },
            {
                "servicio_id": 3,
                "config": {
                    "3": null,
                    "4": null,
                    "6": null,
                    "11": null,
                    "12": null,
                    "13": null,
                    "14": {
                        "default": null,
                        "arable": null,
                        "irrimax":null,
                        "weenat":null,
                        "agviewer":null
                    },
                    "15": null
                },
                "valor": null
            },
            {
                "servicio_id": 4,
                "config": {
                    "farmUser": null,
                    "clientUser": null
                },
                "valor": null
            },
            {
                "servicio_id": 5,
                "config": {
                    "SMS": null,
                    "call": null
                },
                "valor": null
            },
            {
                "servicio_id": 6,
                "config": null,
                "valor": null
            },
            {
                "servicio_id": 7,
                "config": {
                    "farmAPI": null,
                    "clientAPI": null
                },
                "valor": null
            }
        ],
        "servicios": [
            {
                "servicio_id": 1,
                "nombre": "Dropcontrol",
                "config": null
            },
            {
                "servicio_id": 2,
                "nombre": "DataPlan",
                "config": null
            },
            {
                "servicio_id": 3,
                "nombre": "External DataSource",
                "config": {
                    "node_types": []
                }
            },
            {
                "servicio_id": 4,
                "nombre": "User",
                "config": null
            },
            {
                "servicio_id": 5,
                "nombre": "SMS & Calls",
                "config": null
            },
            {
                "servicio_id": 6,
                "nombre": "Images",
                "config": null
            },
            {
                "servicio_id": 7,
                "nombre": "ApiKeys",
                "config": null
            },
        ],
        "periodos":null
    };
    const [currentPriceList, setCurrentPriceList] = useState(null);
    const [isDefault,setIsDefault] = useState(false);
    const [nameList,setNameList] = useState("");
    const [nameError,setNameError] = useState(null);
    const formikRef = useRef(null);
    const [indexes, setIndexes] = useState({
        [SERVICE_DROPCONTROL]:0,
        [SERVICE_DATAPLAN]:1,
        [SERVICE_EXT_DATASOURCE]:2,
        [SERVICE_ADDITIONAL_USER]:3,
        [SERVICE_SMS_CALLS]:4,
        [SERVICE_IMAGES]:5,
        [SERVICE_ADDITIONAL_API]:6,
    });
    useEffect(() => {
        if(data===null){
            RestAPI.get("apiAdminDropControl", "/billing/pricelist").then((response) => {
                if(response?.[0]?.result?.countries.length >0){
                    response?.[0]?.result?.lists.forEach((obj) => {
                        const result = obj.tipo_pais_id?.map(id => {
                            const country = response?.[0]?.result?.countries?.find(item => item?.tipo_pais_id === id);
                            return country ? t(`countries.${country.tipo_pais_id}`) : "";
                        });
                        const text = result?.join(", ");
                        obj.country_list_name =  result??[];
                        obj.country_list_string = result?.length>0?text:t("billing.noCountries");
                    });
                }
                setData(response?.[0]?.result?.lists);
                setCountries(response?.[0]?.result?.countries);
            }).catch((error) => {
                console.error(error);
            });
        }
    },[data,t]);

    useEffect(() => {
        if(currentPriceList != null){
            setNameList(currentPriceList?.nombre??"");
            setIsDefault(currentPriceList?.default_list??false);
            setSelectedCountries(currentPriceList?.tipo_pais_id??[]);
            setOnCreate(true);
        }
    },[currentPriceList]);

    const resetForm = () => {
        setOnCreate(false);
        setCurrentPriceList(null);
        setNameList(null);
        setIsDefault(false);
        setOnSendForm(false);
        setNameError(null);
        gridRef?.current?.refresh();
    };

    const defaultListTemplate = (rowData) => {
        if(rowData?.default_list){
            return (
                <FontAwesomeIcon size="lg" icon={faCheck} style={{ color: "green" }} />
            );
        }else{
            return null;
        }
    };
    const mergeObjects = (obj1, obj2)  => {
        for (const key in obj2) {
            if (Object.prototype.hasOwnProperty.call(obj2, key)) {
                if (typeof obj1[key] === "object" && typeof obj2[key] === "object" && !Array.isArray(obj2[key])) {
                    obj1[key] = mergeObjects(obj1[key], obj2[key]);
                } else {
                    obj1[key] = obj2[key];
                }
            }
        }
        return obj1;
    };


    const selfHelpParams = {
        definitionName: [
            t("selfHelp.priceList.titleProperties.min"),
            t("selfHelp.priceList.titleProperties.max"),
            t("selfHelp.priceList.titleProperties.desc"),
            t("selfHelp.priceList.titleProperties.users"),
            t("selfHelp.priceList.titleProperties.apis"),
            t("selfHelp.priceList.titleProperties.sms"),
            t("selfHelp.priceList.titleProperties.calls")
        ],
        definitionText: [
            t("selfHelp.priceList.properties.rangeMin"),
            t("selfHelp.priceList.properties.rangeMax"),
            t("selfHelp.priceList.properties.discount"),
            t("selfHelp.priceList.properties.includedUser"),
            t("selfHelp.priceList.properties.includedAPI"),
            t("selfHelp.priceList.properties.SMS"),
            t("selfHelp.priceList.properties.calls")
        ]
    };
    const selfHelpImg1 = import.meta.glob("../../img/autoayuda/billing/pricelist/*/new_step_1.png", { eager: true, import: "default" })[`../../img/autoayuda/billing/pricelist/${i18n.language}/new_step_1.png`];
    const selfHelpImg2 = import.meta.glob("../../img/autoayuda/billing/pricelist/*/new_step_2.png", { eager: true, import: "default" })[`../../img/autoayuda/billing/pricelist/${i18n.language}/new_step_2.png`];
    const selfHelpImg3 = import.meta.glob("../../img/autoayuda/billing/pricelist/*/new_step_3.png", { eager: true, import: "default" })[`../../img/autoayuda/billing/pricelist/${i18n.language}/new_step_3.png`];
    const selfHelpImg4 = import.meta.glob("../../img/autoayuda/billing/pricelist/*/new_step_4.png", { eager: true, import: "default" })[`../../img/autoayuda/billing/pricelist/${i18n.language}/new_step_4.png`];
    const selfHelpImg5 = import.meta.glob("../../img/autoayuda/billing/pricelist/*/new_step_5.png", { eager: true, import: "default" })[`../../img/autoayuda/billing/pricelist/${i18n.language}/new_step_5.png`];
    const selfHelpImg6 = import.meta.glob("../../img/autoayuda/billing/pricelist/*/new_step_6.png", { eager: true, import: "default" })[`../../img/autoayuda/billing/pricelist/${i18n.language}/new_step_6.png`];
    const selfHelpImg7 = import.meta.glob("../../img/autoayuda/billing/pricelist/*/success_toast.png", { eager: true, import: "default" })[`../../img/autoayuda/billing/pricelist/${i18n.language}/success_toast.png`];
    const selfHelpImg8 = import.meta.glob("../../img/autoayuda/billing/pricelist/*/error_toast.png", { eager: true, import: "default" })[`../../img/autoayuda/billing/pricelist/${i18n.language}/error_toast.png`];

    const editPriceList = (rowData) => {
        const newObj = {...rowData};
        const defaultObj = {...defaultPriceList};
        const newConfig = mergeObjects(defaultObj.precios[0].config, newObj.precios[newObj.precios.findIndex(s => s.servicio_id === SERVICE_DROPCONTROL)].config);
        newObj.precios[newObj.precios.findIndex(s => s.servicio_id === SERVICE_DROPCONTROL)].config = newConfig;

        const newConfigExt = mergeObjects(defaultObj.precios[2].config, newObj.precios[newObj.precios.findIndex(s => s.servicio_id === SERVICE_EXT_DATASOURCE)].config);
        newObj.precios[newObj.precios.findIndex(s => s.servicio_id === SERVICE_EXT_DATASOURCE)].config = newConfigExt;

        const formatList = mergeObjects(defaultObj,newObj);
        formatList.precios = formatList?.precios?.sort((a, b) => a.servicio_id - b.servicio_id);
        setIndexes(
            {
                [SERVICE_DROPCONTROL]:formatList?.precios?.findIndex(s => s.servicio_id === SERVICE_DROPCONTROL),
                [SERVICE_DATAPLAN]:formatList?.precios?.findIndex(s => s.servicio_id === SERVICE_DATAPLAN),
                [SERVICE_EXT_DATASOURCE]:formatList?.precios?.findIndex(s => s.servicio_id === SERVICE_EXT_DATASOURCE),
                [SERVICE_ADDITIONAL_USER]:formatList?.precios?.findIndex(s => s.servicio_id === SERVICE_ADDITIONAL_USER),
                [SERVICE_SMS_CALLS]:formatList?.precios?.findIndex(s => s.servicio_id === SERVICE_SMS_CALLS),
                [SERVICE_IMAGES]:formatList?.precios?.findIndex(s => s.servicio_id === SERVICE_IMAGES),
                [SERVICE_ADDITIONAL_API]:formatList?.precios?.findIndex(s => s.servicio_id === SERVICE_ADDITIONAL_API),
            }
        );
        if(!formatList.periodos){
            formatList.periodos = [CONTRATO_MENSUAL, CONTRATO_TRIMESTAL, CONTRATO_SEMESTRAL, CONTRATO_ANUAL];
        }
        setCurrentPriceList(formatList);
    };
    const countryTemplate = (rowData) => {
        if(rowData?.tipo_pais_id?.length >0){
            const result = rowData.tipo_pais_id?.map(id => {
                const country = countries?.find(item => item?.tipo_pais_id === id);
                return country ? t(`countries.${country.tipo_pais_id}`) : "";
            });
            const text = result?.join(", ");

            if(text.length>40){
                return(<>
                    <Tooltip target=".text-elipsis" />
                    <div
                        className="text-elipsis"
                        data-pr-tooltip={text}
                        data-pr-position="right"
                    >
                        {text?.substring(0,40)+"..."}
                    </div>
                </>);
            }else{
                return <div className="text-elipsis">{text}</div>;
            }
        }else {
            return t("billing.noCountries");
        }
    };
    return (
        <div className='row-container'>
            <div className='row'>
                <div className="col-xl-12 col-lg-12 col-sm-12">
                    <div id="cardRaw" className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className="col-xl-3 col-lg-12 col-sm-12">
                                    {selfHelpParams &&
                                        <SelfHelp
                                            t={t}
                                            lng={i18n.language}
                                            target="PriceList"
                                            images={[
                                                selfHelpImg1,
                                                selfHelpImg2,
                                                selfHelpImg3,
                                                selfHelpImg4,
                                                selfHelpImg5,
                                                selfHelpImg6,
                                                selfHelpImg7,
                                                selfHelpImg8
                                            ]}
                                            params={selfHelpParams}
                                        />}
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12 text-center">
                                    <h5 className="card-title"><span>{t("billing.priceListPage.title")}</span></h5>
                                </div>
                                <div className='col-xl-3 col-lg-12 col-sm-12 d-flex justify-content-end align-items-right align-items-center'>
                                    {
                                        !onCreate?
                                            <ButtonPrime  t={t} link raised={false} onClick={() => formikRef.current && formikRef.current.submitForm()} tooltip={t("billing.priceListPage.addList")} tooltipOptions={{ className:"tooltip-prime", position:"left"}}>
                                                <FontAwesomeIcon
                                                    size="lg" style={{ color: "grey"}} icon={faPlusCircle}
                                                    onClick={() => setOnCreate(true)}
                                                >
                                                    {t("forms.save")}
                                                </FontAwesomeIcon>
                                            </ButtonPrime>
                                            :<>
                                                <ButtonPrime t={t} template="formSave" onClick={() => formikRef.current && formikRef.current.submitForm()} tooltip={t("forms.save")} tooltipOptions={{ className:"tooltip-prime", position:"bottom"}} />
                                                <ButtonPrime t={t} template="formCancel" onClick={() => resetForm()} tooltip={t("forms.cancel")}
                                                    tooltipOptions={{ className:"tooltip-prime", position:"bottom"}}
                                                />
                                            </>
                                    }
                                </div>
                            </div>
                            <div className='linea-titulo' />

                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                                    <div className="row linea-formulario">
                                        {onCreate?
                                            <>
                                                <div className="col-xl-1 col-lg-12 col-sm-12 text-md-right mtem-05">
                                                    <label className="boldie">{t("general.name")}</label>
                                                </div>
                                                <div className='col-xl-2 col-lg-12 col-sm-12 text-left'>
                                                    <InputText
                                                        value={nameList}
                                                        onBlur={(e) => {setNameError(e.target.value === "");}}
                                                        onChange={(e) => {
                                                            setNameError(e.target.value === "");
                                                            setNameList(e.target.value);}}
                                                    />
                                                    {nameError?<small className="p-error text-danger">{t("billing.formValidation.name")}</small>:null}
                                                </div>
                                                <div className="col-xl-2 col-lg-12 col-sm-12 text-md-right mtem-05">
                                                    <label className="boldie">{t("billing.countryList")}</label>
                                                </div>
                                                <div className='col-xl-3 col-lg-12 col-sm-12 text-left'>
                                                    <MultiSelect
                                                        style={{width:"100%"}}
                                                        optionValue='tipo_pais_id' panelClassName='fnSm'
                                                        value={selectedCountries} onChange={(e) => setSelectedCountries(e.value)}
                                                        options={countries} optionLabel="nombre" placeholder={t("billing.selectCountries")}
                                                        maxSelectedLabels={3} className="fnSm"  selectAll selectAllLabel={t("forms.selectAll")}
                                                    />
                                                </div>
                                                <div className="col-xl-2 col-lg-12 col-sm-12 text-md-right mtem-05">
                                                    <label className="boldie">{t("billing.defaultList")}</label>
                                                </div>
                                                <div className="col-xl-1 col-lg-12 col-sm-12 text-md-left">
                                                    <InputSwitch checked={isDefault} onChange={(e) => setIsDefault(e.value)} />
                                                </div>
                                            </>
                                            :
                                            (data===null || countries===null) ?
                                                <LoadingDialog />
                                                :
                                                <DataTablePrime
                                                    t={t}
                                                    value={data}
                                                    scrollHeight="55vh"
                                                    paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
                                                    size="small"
                                                    dataKey="lista_precio_id"
                                                    filters={{
                                                        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                        nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                        country_list_string: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                    }}
                                                    header="search"
                                                    globalFilterFields={["nombre", "country_list_string"]}
                                                    fields={[
                                                        {field:"nombre",header:names[0], bodyStyle:{textAlign:"center"}},
                                                        {field:"country_list",header:"", body:countryTemplate, bodyStyle:{textAlign:"center"}},
                                                        {field:"default_list",header:"", body:defaultListTemplate, bodyStyle:{textAlign:"center"}},
                                                    ]}
                                                    editableRow
                                                    editFunction= {(event, rowData) => {
                                                        editPriceList(rowData);
                                                    }}
                                                />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                onCreate?
                    <Formik innerRef={formikRef}
                        initialValues={currentPriceList===null?
                            defaultPriceList
                            :currentPriceList}
                        validate={(data) => {
                            const errors = {};
                            data.nombre = nameList;
                            if (!data.nombre || data.nombre === "") {
                                errors.nombre = "Required";
                                setNameError(true);
                            }
                            for (const discount of (data?.config_descuentos ?? [])) {
                                if (discount.rangeMin === null || discount.rangeMax === null) {
                                    errors.config_descuentos = "Required";
                                    break;
                                }
                            }
                            return errors;
                        }}
                        onSubmit={async (formData) => {
                            setOnSendForm(true);
                            formData.default_list = isDefault;
                            formData.tipo_pais_id = selectedCountries;
                            formData.nombre = nameList;
                            formData.indexes = indexes;
                            if(formData.periodos.length===4){
                                formData.periodos=null;
                            }
                            if(formData.lista_precio_id){
                                await RestAPI.put("apiAdminDropControl", "/billing/pricelist", {body: formData}).then(async (response) => {
                                    const index = data.findIndex((d) => {
                                        return d.lista_precio_id === (response?.list?.[0]?.lista_precio_id);
                                    });
                                    if(index !== -1){
                                        const result = response?.list?.[0]?.tipo_pais_id?.map(id => {
                                            const country = countries?.find(item => item?.tipo_pais_id === id);
                                            return country ? t(`countries.${country.tipo_pais_id}`) : "";
                                        });
                                        const text = result?.join(", ");
                                        response.list[0].country_list_name =  result??[];
                                        response.list[0].country_list_string = result?.length>0?text:t("billing.noCountries");
                                        const prices = response?.services?.map(p => p);
                                        data[index] = {...response.list[0],precios:prices};
                                    }
                                    toast.success(t("billing.priceListPage.successEdit"), { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 });
                                    resetForm();
                                })
                                    .catch((error) => {
                                        if (error.response.status === 409) {
                                            const result = error?.response?.data?.map(id => {
                                                const country = countries.find(item => item?.tipo_pais_id === id);
                                                return country ? t(`countries.${country.tipo_pais_id}`) : "";
                                            });
                                            const list = result?.join(", ");
                                            if(result.length === 1){
                                                toast.error(t("billing.error409Country", { list }), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                            }else{
                                                toast.error(t("billing.error409Countries", { list }), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                            }setOnSendForm(false);
                                        }else{
                                            setOnSendForm(false);
                                            toast.error(t("billing.priceListPage.error"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                            console.log(error);
                                        }
                                    });
                            }else{
                                await RestAPI.post("apiAdminDropControl", "/billing/pricelist", {body: formData}).then(async (response) => {
                                    const newData = {...response.list[0],precios:response.services};
                                    const result = newData.tipo_pais_id?.map(id => {
                                        const country = countries.find(item => item?.tipo_pais_id === id);
                                        return country ? t(`countries.${country.tipo_pais_id}`) : "";
                                    });
                                    const text = result?.join(", ");
                                    newData.country_list_name =  result??[];
                                    newData.country_list_string = result?.length>0?text:t("billing.noCountries");
                                    data.push(newData);
                                    toast.success(t("billing.priceListPage.successSave"), { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 });
                                    resetForm();
                                })
                                    .catch((error) => {
                                        if (error?.response?.status === 409) {
                                            const result = error?.response?.data?.map(id => {
                                                const country = countries.find(item => item?.tipo_pais_id === id);
                                                return country ? t(`countries.${country.tipo_pais_id}`) : "";
                                            });
                                            const list = result?.join(", ");
                                            if(result.length === 1){
                                                toast.error(t("billing.error409Country", { list }), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                            }else{
                                                toast.error(t("billing.error409Countries", { list }), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                            }
                                            setOnSendForm(false);
                                        }else{
                                            console.log(error);
                                            setOnSendForm(false);
                                            toast.error(t("billing.priceListPage.error"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                        }
                                    });
                            }
                        }}
                    >
                        {formik => (
                            <form onSubmit={formik.handleSubmit} className='row'>
                                {onSendForm?<LoadingDialog />:null}
                                <PriceListServices formik={formik} currentPriceList={currentPriceList} indexes={indexes} />
                                <PriceListDiscounts formik={formik} />
                            </form>
                        )}
                    </Formik>
                    :null
            }
        </div>
    );
};

export default withName(PriceList, "PriceList");
